export default ['1 - 200', '201 - 1,000', '1,001 - 5,000', '5,001 - 20,000', '20,000+']